import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import FAQAccordion from "./FAQAccordion";

const Faq = () => {
    const theme = useTheme();
    return (
        <Box
            id="faq"
            sx={{
                width: '100%',
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1,
                    background: theme.palette.primary.main,
                }}
            />
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 3,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 8,
                    maxWidth: '1400px',
                    mx: 'auto',
                }}
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                >
                    <Box
                        display="flex"
                        gap={1.2}
                        mb={1.6}
                        alignItems="center"
                    >
                        <Box sx={{ background: '#306FE8', width: '20px', height: '20px', borderRadius: 0.6 }}></Box>
                        <Typography fontSize={22} color={theme.palette.secondary.main}>FAQs</Typography>
                    </Box>
                    <Box width="45%">
                        <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600" sx={{ lineHeight: 1.1 }}>Frequently Asked Questions</Typography>
                    </Box>
                    <Typography fontSize={18} mt={1}>Have another question? Please contact our team!</Typography>
                </Box>
                <FAQAccordion />
            </Box>
        </Box>
    )
}

export default Faq;